import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  Button,
  Flex,
  FormElement,
  Grid,
  GridCell,
  Panel,
  Spinner,
  Text,
} from 'mailup-web-components'

import InputFrom from 'Pages/GroupsOverlap/components/InputFrom'
import InputTo from 'Pages/GroupsOverlap/components/InputTo'
import { searchCallback } from 'Pages/GroupsOverlap/recoil/callbacks/callbacks'
import {
  canSearchState,
  searchFromCounterState,
  searchState,
} from 'Pages/GroupsOverlap/recoil/state/state'

const Search: FC = () => {
  const intl = useIntl()

  const { from, fromIsDirty, to, toIsDirty } = useRecoilValue(searchState)
  const searchFromCounter = useRecoilValue(searchFromCounterState)
  const canSearch = useRecoilValue(canSearchState)
  const handleSearch = useRecoilCallback(searchCallback, [])

  const fromFeedback =
    fromIsDirty && from === undefined
      ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
      : undefined

  const toFeedback =
    toIsDirty && to.length === 0
      ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
      : undefined

  return (
    <Panel data-mu-test="panel-search" margin="0">
      <Flex flexDirection="column" gap="24px">
        <Grid cols={2}>
          <GridCell>
            <FormElement
              data-mu-test="group-source"
              label={intl.formatMessage({
                id: 'Load.GroupsOverlap.GroupSourceLabel',
              })}
              feedback={fromFeedback}
              feedbackVariant={fromFeedback !== undefined ? 'error' : undefined}
            >
              <Flex flexDirection="column" gap="8px">
                <InputFrom />
                <Text>
                  {searchFromCounter.status === 'loading' && <Spinner />}
                  {searchFromCounter.status === 'ready' &&
                    intl.formatMessage(
                      { id: 'Load.GroupsOverlap.GroupSubscribers' },
                      {
                        N: searchFromCounter.count,
                        strong: (chunks) => <strong>{chunks}</strong>,
                      },
                    )}
                </Text>
              </Flex>
            </FormElement>
          </GridCell>
          <GridCell>
            <FormElement
              data-mu-test="group-dest"
              label={intl.formatMessage({
                id: 'Load.GroupsOverlap.GroupDestLabel',
              })}
              feedback={toFeedback}
              feedbackVariant={toFeedback !== undefined ? 'error' : undefined}
            >
              <InputTo />
            </FormElement>
          </GridCell>
        </Grid>

        <Flex justifyContent="end">
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            data-mu-test="groups-verify"
            disabled={!canSearch}
            onClick={handleSearch}
          >
            {intl.formatMessage({ id: 'Load.GroupsOverlap.Verify' })}
          </Button>
        </Flex>
      </Flex>
    </Panel>
  )
}

export default Search
